import { Box, TextField, Typography } from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Gift from '../../../assets/images/icons/gift_white.png';
import Starcard from '../../../assets/images/pages/register/starcard.png';
import RegisterLayout from '../../../components/layouts/RegisterLayout';
import AppButton from '../../../components/ui/AppButton';

const RegisterPhone = ({ phoneNumber, setPhoneNumber, onSubmit, isLoading }) => {
  const formik = useFormik({
    initialValues: {
      phonenumber: phoneNumber,
    },
    validationSchema: Yup.object({
      phonenumber: Yup.string()
        .min(10, 'โปรดระบุเบอร์โทรศัพท์อย่างน้อย 10 หลัก')
        .required('โปรดระบุเบอรโทรศัพท์ให้ถูกต้อง'),
    }),
    onSubmit: (values) => {
      setPhoneNumber(values.phonenumber);
      onSubmit(values.phonenumber);
    },
  });

  return (
    <RegisterLayout>
      {/* Starcard */}
      <Box
        component={'img'}
        src={Starcard}
        alt="Starcard Image"
        sx={{ width: '80%', maxWidth: 450, position: 'absolute', top: 0, right: 0 }}
      />

      {/* Form */}
      <form onSubmit={formik.handleSubmit}>
        <Box
          sx={{
            height: 'calc(100dvh - 60px)',
            position: 'relative',
            zIndex: '10',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
          }}
        >
          <Box sx={{ height: '300px', padding: '16px' }}>
            <Typography
              component="h1"
              sx={{
                fontSize: '2.5rem',
                fontWeight: '700',
                color: '#005972',
                textAlign: 'center',
                marginBottom: '10px',
              }}
            >
              สมัครสมาชิก
            </Typography>

            <TextField
              id="phonenumber"
              name="phonenumber"
              placeholder="เบอร์มือถือ"
              variant="outlined"
              inputProps={{ maxLength: '10', inputMode: 'numeric', pattern: '[0-9]*' }}
              value={formik.values.phonenumber}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              fullWidth
              sx={{
                '& .MuiInputBase-root': {
                  fontSize: '1.5rem',
                  borderRadius: '8px',
                  backgroundColor: 'white',
                  outline: formik.errors.phonenumber ? '2px solid #dc2626' : 'none',
                },
                '& .MuiInputBase-input': {
                  padding: '0 1.25rem',
                  height: '50px',
                  color: '#005972',
                },
                '& .MuiInputBase-input::placeholder': {
                  fontSize: '1.5rem',
                },
              }}
            />
            {formik.touched.phonenumber && formik.errors.phonenumber && (
              <Typography sx={{ padding: '0.5rem 0', color: '#dc2626' }}>
                {formik.errors.phonenumber}
              </Typography>
            )}

            <AppButton
              type="submit"
              variant="registerPrimary"
              disabled={isLoading}
              fullWidth
              sx={{ width: '160px', height: '45px', display: 'block', margin: '10px auto' }}
            >
              ขอรหัส OTP
            </AppButton>
          </Box>

          <Box
            sx={{
              backgroundColor: '#E1000C',
              width: '100%',
              padding: '16px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              height: '130px',
            }}
          >
            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <Typography
                  sx={{
                    fontSize: '2rem',
                    lineHeight: '1.75rem',
                    fontWeight: '700',
                    color: 'white',
                  }}
                >
                  สตาร์การ์ด คลับ 2026
                </Typography>
                <Box
                  component={'img'}
                  src={Gift}
                  alt="Gift Icon"
                  sx={{ width: '35px', marginTop: '-5px' }}
                />
              </Box>
              <Typography
                sx={{
                  fontSize: '1.25rem',
                  lineHeight: '1.4rem',
                  fontWeight: '500',
                  color: 'white',
                }}
              >
                จากโรงกลั่น...สู่ธุรกิจคุณ
                <br />
                เปลี่ยนทุกลิตรเป็นคะแนน สะสมของรางวัลสุดคุ้ม
              </Typography>
            </Box>
          </Box>
        </Box>
      </form>
    </RegisterLayout>
  );
};

export default RegisterPhone;
